// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.success-screen {
  text-align: center;
  padding: 40px 20px;
}

.success-icon {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: #4CAF50;
  color: white;
  font-size: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 30px;
}

.success-screen h2 {
  color: #333;
  margin-bottom: 15px;
  font-size: 28px;
}

.success-screen .subtitle {
  color: #666;
  font-size: 16px;
  margin-bottom: 30px;
}

.appointment-details {
  background-color: #f5f5f5;
  border-radius: 8px;
  padding: 20px;
  margin: 30px auto;
  max-width: 500px;
  text-align: left;
}

.appointment-details h3 {
  color: #333;
  font-size: 18px;
  margin-bottom: 15px;
  text-align: center;
}

.detail-row {
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 1px solid #e0e0e0;
}

.detail-row:last-of-type {
  border-bottom: none;
}

.detail-label {
  font-weight: 600;
  color: #666;
  flex: 0 0 120px;
}

.detail-value {
  color: #333;
  flex: 1 1;
  text-align: right;
}

.download-calendar-button {
  background-color: #f0f0f0;
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 10px 20px;
  margin-top: 15px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: block;
  width: 100%;
  text-align: center;
  color: #333;
}

.download-calendar-button:hover {
  background-color: #e8e8e8;
  border-color: #ccc;
}

.body-text {
  color: #666;
  font-size: 14px;
  margin: 20px 0 30px;
}

/* CIN-6621: shown when the shop's system cannot receive cancels/changes. */
.change-blocked-notice {
  background-color: #fff8e1;
  border: 1px solid #ffe082;
  border-radius: 8px;
  color: #6d4c00;
  font-size: 14px;
  line-height: 1.5;
  margin: 0 auto;
  max-width: 500px;
  padding: 12px 16px;
  text-align: center;
}

.change-blocked-notice .change-blocked-phone {
  color: #6d4c00;
  font-weight: 600;
  white-space: nowrap;
}

.action-buttons {
  display: flex;
  gap: 12px;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 30px;
}

.action-buttons .action-button.disabled,
.action-buttons .action-button:disabled {
  background-color: #f0f0f0;
  border-color: #e0e0e0;
  color: #b3b7c1;
  cursor: not-allowed;
}

.action-buttons .action-button {
  min-width: 150px;
  padding: 12px 20px;
}

@media (max-width: 600px) {
  .action-buttons {
    flex-direction: column;
    align-items: center;
  }
  
  .action-buttons .action-button {
    width: 100%;
    max-width: 300px;
  }
  
  .detail-row {
    flex-direction: column;
    gap: 5px;
  }
  
  .detail-value {
    text-align: left;
  }
  
  .detail-label {
    font-weight: 600;
    color: #666;
    flex: 0 0 12px;
  }
}

.cancel-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.cancel-modal-content {
  background: white;
  border-radius: 12px;
  padding: 30px;
  max-width: 400px;
  width: 100%;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  animation: cancelModalSlideIn 0.3s ease-out;
}

@keyframes cancelModalSlideIn {
  from {
    transform: translateY(-20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.cancel-modal-content h3 {
  margin: 0 0 15px 0;
  font-size: 24px;
  color: #333;
  text-align: center;
}

.cancel-modal-content p {
  margin: 0 0 15px 0;
  color: #666;
  font-size: 16px;
  text-align: center;
  line-height: 1.5;
}

.cancel-modal-content .cancel-modal-warning-text {
  color: #d32f2f;
  font-size: 14px;
  background-color: #ffebee;
  padding: 10px 15px;
  border-radius: 6px;
  margin: 20px 0;
}

.cancel-modal-actions {
  display: flex;
  gap: 12px;
  margin-top: 25px;
  justify-content: center;
}

.cancel-modal-button {
  padding: 12px 24px;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s ease;
  min-width: 140px;
}

.cancel-modal-button.cancel {
  background-color: #f5f5f5;
  color: #333;
}

.cancel-modal-button.cancel:hover {
  background-color: #e0e0e0;
}

.cancel-modal-button.confirm {
  background-color: #d32f2f;
  color: white;
}

.cancel-modal-button.confirm:hover {
  background-color: #c62828;
}

@media (max-width: 480px) {
  .cancel-modal-content {
    padding: 20px;
  }
  
  .cancel-modal-actions {
    flex-direction: column;
  }
  
  .cancel-modal-button {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/SuccessScreen.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,SAAO;EACP,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA,2EAA2E;AAC3E;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,cAAc;EAChB;AACF;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,0CAA0C;EAC1C,2CAA2C;AAC7C;;AAEA;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".success-screen {\n  text-align: center;\n  padding: 40px 20px;\n}\n\n.success-icon {\n  width: 80px;\n  height: 80px;\n  border-radius: 50%;\n  background-color: #4CAF50;\n  color: white;\n  font-size: 48px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 30px;\n}\n\n.success-screen h2 {\n  color: #333;\n  margin-bottom: 15px;\n  font-size: 28px;\n}\n\n.success-screen .subtitle {\n  color: #666;\n  font-size: 16px;\n  margin-bottom: 30px;\n}\n\n.appointment-details {\n  background-color: #f5f5f5;\n  border-radius: 8px;\n  padding: 20px;\n  margin: 30px auto;\n  max-width: 500px;\n  text-align: left;\n}\n\n.appointment-details h3 {\n  color: #333;\n  font-size: 18px;\n  margin-bottom: 15px;\n  text-align: center;\n}\n\n.detail-row {\n  display: flex;\n  justify-content: space-between;\n  padding: 10px 0;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.detail-row:last-of-type {\n  border-bottom: none;\n}\n\n.detail-label {\n  font-weight: 600;\n  color: #666;\n  flex: 0 0 120px;\n}\n\n.detail-value {\n  color: #333;\n  flex: 1;\n  text-align: right;\n}\n\n.download-calendar-button {\n  background-color: #f0f0f0;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  padding: 10px 20px;\n  margin-top: 15px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: block;\n  width: 100%;\n  text-align: center;\n  color: #333;\n}\n\n.download-calendar-button:hover {\n  background-color: #e8e8e8;\n  border-color: #ccc;\n}\n\n.body-text {\n  color: #666;\n  font-size: 14px;\n  margin: 20px 0 30px;\n}\n\n/* CIN-6621: shown when the shop's system cannot receive cancels/changes. */\n.change-blocked-notice {\n  background-color: #fff8e1;\n  border: 1px solid #ffe082;\n  border-radius: 8px;\n  color: #6d4c00;\n  font-size: 14px;\n  line-height: 1.5;\n  margin: 0 auto;\n  max-width: 500px;\n  padding: 12px 16px;\n  text-align: center;\n}\n\n.change-blocked-notice .change-blocked-phone {\n  color: #6d4c00;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.action-buttons {\n  display: flex;\n  gap: 12px;\n  justify-content: center;\n  flex-wrap: wrap;\n  margin-top: 30px;\n}\n\n.action-buttons .action-button.disabled,\n.action-buttons .action-button:disabled {\n  background-color: #f0f0f0;\n  border-color: #e0e0e0;\n  color: #b3b7c1;\n  cursor: not-allowed;\n}\n\n.action-buttons .action-button {\n  min-width: 150px;\n  padding: 12px 20px;\n}\n\n@media (max-width: 600px) {\n  .action-buttons {\n    flex-direction: column;\n    align-items: center;\n  }\n  \n  .action-buttons .action-button {\n    width: 100%;\n    max-width: 300px;\n  }\n  \n  .detail-row {\n    flex-direction: column;\n    gap: 5px;\n  }\n  \n  .detail-value {\n    text-align: left;\n  }\n  \n  .detail-label {\n    font-weight: 600;\n    color: #666;\n    flex: 0 0 12px;\n  }\n}\n\n.cancel-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 20px;\n}\n\n.cancel-modal-content {\n  background: white;\n  border-radius: 12px;\n  padding: 30px;\n  max-width: 400px;\n  width: 100%;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n  animation: cancelModalSlideIn 0.3s ease-out;\n}\n\n@keyframes cancelModalSlideIn {\n  from {\n    transform: translateY(-20px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n.cancel-modal-content h3 {\n  margin: 0 0 15px 0;\n  font-size: 24px;\n  color: #333;\n  text-align: center;\n}\n\n.cancel-modal-content p {\n  margin: 0 0 15px 0;\n  color: #666;\n  font-size: 16px;\n  text-align: center;\n  line-height: 1.5;\n}\n\n.cancel-modal-content .cancel-modal-warning-text {\n  color: #d32f2f;\n  font-size: 14px;\n  background-color: #ffebee;\n  padding: 10px 15px;\n  border-radius: 6px;\n  margin: 20px 0;\n}\n\n.cancel-modal-actions {\n  display: flex;\n  gap: 12px;\n  margin-top: 25px;\n  justify-content: center;\n}\n\n.cancel-modal-button {\n  padding: 12px 24px;\n  border: none;\n  border-radius: 6px;\n  font-size: 16px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: all 0.2s ease;\n  min-width: 140px;\n}\n\n.cancel-modal-button.cancel {\n  background-color: #f5f5f5;\n  color: #333;\n}\n\n.cancel-modal-button.cancel:hover {\n  background-color: #e0e0e0;\n}\n\n.cancel-modal-button.confirm {\n  background-color: #d32f2f;\n  color: white;\n}\n\n.cancel-modal-button.confirm:hover {\n  background-color: #c62828;\n}\n\n@media (max-width: 480px) {\n  .cancel-modal-content {\n    padding: 20px;\n  }\n  \n  .cancel-modal-actions {\n    flex-direction: column;\n  }\n  \n  .cancel-modal-button {\n    width: 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
